<template>
  <svg
    :class="computedClass"
    :width="size"
    :height="size"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.7353 34.5183C32.7353 34.5183 29.5271 33.1174 27.2877 32.3035C25.8185 31.7635 26.025 29.3217 26.8747 28.3983C28.3676 26.9583 29.1062 24.9156 28.8759 22.873C29.003 21.5348 28.5423 20.2044 27.6132 19.2261C26.6841 18.2478 25.3659 17.7078 24.0079 17.7391C22.6421 17.7 21.3318 18.24 20.3947 19.2261C19.4656 20.2044 19.005 21.5348 19.1321 22.873C18.9018 24.9235 19.6403 26.9583 21.1332 28.3983C21.983 29.3139 22.1973 31.7635 20.7203 32.3035C18.4809 33.1252 15.2727 34.5183 15.2727 34.5183M35.9118 12.2609V7.56522C35.9118 6.70435 35.1971 6 34.3235 6L13.6765 6C11.9215 6 10.5 7.40087 10.5 9.13043M35.9118 12.2609L13.6765 12.2609C11.9215 12.2609 10.5 10.86 10.5 9.13043M35.9118 12.2609C36.7853 12.2609 37.5 12.9652 37.5 13.8261L37.5 40.4348C37.5 41.2957 36.7853 42 35.9118 42L13.6765 42C11.9215 42 10.5 40.5991 10.5 38.8696L10.5 9.13043M13.6765 9.13043L31.1471 9.13043C32.0206 9.13043 32.7353 9.83478 32.7353 10.6957V12.2609"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  size?: number | string;
  color?: string;
  class?: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: 24,
  color: "currentColor",
  class: "",
});

const computedClass = computed(() => props.class);
</script>
